import { Injectable, Inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { UserInfo } from 'src/app/models';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root'
})
export class UpdateDetailsService {
  phoneCodeOptions:any;
  constructor( private appConfigService:AppConfigService ) {

  }


  //TODO get mobile prefix numbers
   getPhoneCode(): Observable<any> {
    this.appConfigService.getPhonePrefix().subscribe(
      (data) => {
        this.phoneCodeOptions = data;
      },
      (error)=>{
        //TODO
      })
    return of(this.phoneCodeOptions);
    // var phoneCodeOptions = this._http.get<any>(`${this.baseApi}/GetPreffixList`);
    // return phoneCodeOptions;

  }


}
